import { motion, type Transition } from "framer-motion";

export default function GradientText({ className, text }: { className?: string; text?: string }) {
  /**
   * Gradient and animation settings
   */
  const gradient = "linear-gradient(90deg, #3b82f6 0%, #a855f7 33%, #ec4899 66%, #3b82f6 100%)";

  const animation = {
    backgroundPositionX: ["200%", "0%"],
  };

  const transition: Transition = {
    duration: 3,
    ease: "linear",
    repeat: Infinity,
  };

  return (
    <div className={`relative inline-flex ${className} 2xl:pr-8 py-4 2xl:py-8 overflow-visible`}>
      {/* Glow effect */}
      <motion.div
        aria-hidden
        className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ml-4 blur-lg rounded-full w-full aspect-square'
        style={{
          backgroundImage: gradient,
          backgroundSize: "200% 100%",
          opacity: 0.25,
          WebkitMaskImage: "radial-gradient(ellipse 67% 15% at center, black 0%, black 50%, transparent 85%)",
          maskImage: "radial-gradient(ellipse 67% 15% at center, black 0%, black 50%, transparent 85%)",
        }}
        animate={animation}
        transition={transition}
      />

      {/* Main text */}
      <motion.p
        className='relative bg-clip-text text-transparent'
        style={{
          backgroundImage: gradient,
          backgroundSize: "200% 100%",
        }}
        animate={animation}
        transition={transition}
      >
        {text}
      </motion.p>
    </div>
  );
}
